import type { ActivePluginSet } from "./orgPlugins";

/**
 * Published plugin sets by organization key. Lives in its own import-free
 * module so test setup can clear it without loading the organization query
 * graph (which individual tests mock).
 */
export const activePluginsByKey = new Map<string, ActivePluginSet>();

/** Test cleanup only: drops every published set so tests cannot share state. */
export function clearActivePlugins(): void {
  activePluginsByKey.clear();
}
